import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Approach, Contact, FAQs, Home, Story, Success } from "./pages";

export const WebRoutes = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route index path="/" element={<Home />} />
          <Route index path="/story" element={<Story />} />
          <Route index path="/approach" element={<Approach />} />
          <Route index path="/faq" element={<FAQs />} />
          <Route index path="/contact" element={<Contact />} />
          <Route index path="/success" element={<Success />} />
        </Routes>
      </Router>
    </>
  );
};
